<template>
  <div class="container is-paddingless-mobile">
    <v-email
      v-show="view == 'email'"
      @login="view = 'login'; email = $event;"
      @register="view = 'register'; email = $event;"
    />
    <v-login
      v-show="view == 'login'"
      :email="email"
      @back="view = 'email'"
    />
    <v-register
      v-show="view == 'register'"
      :email="email"
      :host-type="hostType"
      :host-id="hostId"
      @back="view = 'email'"
    />
  </div>
</template>

<script>
import EmailVue from "./Email.vue";
import LoginVue from "./Login.vue";
import RegisterVue from "./Register.vue";

export default {
  components: {
    "v-email": EmailVue,
    "v-login": LoginVue,
    "v-register": RegisterVue,
  },
  props: {
    hostType: {
      required: true,
      type: String
    },
    hostId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      email: null,
      view: "email"
    };
  }
};
</script>
